import { render } from "./YourDataOptions.vue?vue&type=template&id=d87f459a&scoped=true&ts=true"
import script from "./YourDataOptions.vue?vue&type=script&lang=ts"
export * from "./YourDataOptions.vue?vue&type=script&lang=ts"

import "./YourDataOptions.vue?vue&type=style&index=0&id=d87f459a&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87f459a"]])

export default __exports__